import React from 'react';
import langConf from "../js/lang";
//import Select from 'react-select';

class LanguageDropdown extends React.Component {
    state = { currentLanguage: this.props.language }

    // handleSelection = async (event) => {
    //     await this.props.changeLanguage(event.value);
    //     this.setState({ currentLanguage: event.value });
    // };

    handleSelection = async (event) => {
        await this.props.changeLanguage(event.target.value);
        this.setState({ currentLanguage: event.target.value });
    };

    render() {
        const lang = this.props.language;
        //console.log('currentLanguage: ', this.state.currentLanguage);
        //console.log('this.props.language: ', this.props.language);
        // const options = [
        //     { value: "hebrew", label: langConf[lang].hebrew },
        //     { value: "english", label: langConf[lang].english }
        // ];
        return (
            <div className="col-xl-12 col-lg-12 col-md-12 com-sm-12 col-12">
                {/* <Select
                options={options}
                id='language'
                defaultValue={{ value: this.state.currentLanguage, label: langConf[lang].currentLanguage }}
                //defaultValue={{ value: this.props.lang, label: langConf[lang].currentLanguage }}
                className={`selectpicker input-lg col-xl-3 col-lg-3 col-md-3 col-sm-5 col-5`}
                data-live-search="true"
                style={{ textAlign: 'right' }}
                onChange={this.handleSelection}
            /> */}
                <div className="btn-group" role="group" aria-label="..." style={{direction: 'ltr'}}>
                    <button type="button" className="btn btn-default" value='english' style={{borderColor: 'black'}} onClick={this.handleSelection}>{langConf[lang].english}</button>
                    <button type="button" className="btn btn-default" value='hebrew' style={{borderColor: 'black'}} onClick={this.handleSelection}>{langConf[lang].hebrew}</button>
                </div>
            </div>
        );
    }
}

export default LanguageDropdown;
